import { QuizIdentifierDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useApiClient } from '@/api/util/useApiClient.util.ts';
import { useUserContext } from '@/utils/providers/userContext/useUserContext.tsx';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

type Response = QuizIdentifierDto | undefined;

interface Return {
  isGettingQuizIdentifier: boolean;
  quizIdentifier: Response;
  quizIdentifierError: AxiosError | null;
}

export const useGetQuizIdentifiers = (): Return => {
  const { restQuizApi } = useApiClient();
  const { user } = useUserContext();
  const { data, error, isLoading } = useQuery<Response, AxiosError>({
    queryFn: async () => {
      const response = await restQuizApi.getQuizIdentifiers();
      return response.data?.[0];
    },
    queryKey: [QueryKeyEnum.GET_QUIZ_IDENTIFIERS, user?.userId],
  });

  return {
    isGettingQuizIdentifier: isLoading,
    quizIdentifier: data,
    quizIdentifierError: error,
  };
};
